import React, { useEffect, useState } from 'react';
export function ExitPopup() {
  const [showPopup, setShowPopup] = useState(false);
  const [mouseLeft, setMouseLeft] = useState(false);
  useEffect(() => {
    const handleMouseLeave = e => {
      // Only trigger when mouse moves toward the top of the page
      if (e.clientY <= 20 && !mouseLeft) {
        setShowPopup(true);
        setMouseLeft(true);
      }
    };
    document.addEventListener('mouseleave', handleMouseLeave);
    return () => {
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [mouseLeft]);
  if (!showPopup) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4" data-id="element-301">
      <div className="bg-white rounded-lg p-6 max-w-md w-full relative" data-id="element-302">
        <button onClick={() => setShowPopup(false)} className="absolute top-2 right-2 text-gray-500 hover:text-gray-700" aria-label="Stäng" data-id="element-303">
          ✕
        </button>
        <div className="text-center mb-6" data-id="element-304">
          <h2 className="text-2xl font-bold text-[#2e7d32]" data-id="element-305">Innan du går...</h2>
          <p className="text-lg mt-2" data-id="element-306">Kan jag fråga dig något?</p>
        </div>
        <div className="mb-6" data-id="element-307">
          <p className="mb-4" data-id="element-308">
            <span className="font-semibold" data-id="element-309">
              Hur många gånger har du tappat tråden den senaste veckan?
            </span>{' '}
            Hur många gånger har du känt den där tysta paniken när ett namn
            eller ett ord försvinner mitt i en mening?
          </p>
          <p className="mb-4" data-id="element-310">
            Varje gång det händer är det en liten påminnelse om att något
            förändras. Något som du inte kan kontrollera med bara viljestyrka.
          </p>
          <p className="mb-4" data-id="element-311">
            Vad är värdet av att känna sig mentalt skarp igen? Av att slippa oro
            varje gång du ska berätta något viktigt?
          </p>
        </div>
        <div className="space-y-4" data-id="element-312">
          <a href="https://track.decidely.se/click" className="block w-full bg-[#2e7d32] hover:bg-[#1b5e20] text-white text-center font-bold py-3 px-4 rounded-lg transition duration-300" data-id="element-313">
            Jag vill känna mig skarp igen
          </a>
          <button onClick={() => setShowPopup(false)} className="block w-full text-gray-500 text-center py-2 px-4 text-sm" data-id="element-314">
            Nej tack, jag accepterar min tilltagande glömska
          </button>
        </div>
      </div>
    </div>;
}